var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":"","header":_vm.header}},[_c('b-card-body',[_c('bootstrap-table',{ref:"table",attrs:{"columns":_vm.columns,"data":_vm.data,"options":_vm.options}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }